import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useTheme } from '../../ThemeContext';

import IMAGE_LOADER_VIOLET from '../../assets/Images/LoaderViolet.svg';

import { Wrapper, Content, Icon, Text } from './LoadingData.style';

const LoadingData = ({ fullmode = false }) => {
  const intl = useIntl();
  const theme = useTheme();
  return (
    <Wrapper theme={theme.loadingData} fullmode={fullmode ? true : undefined}>
      <Content>
        <Icon
          src={IMAGE_LOADER_VIOLET}
          alt={intl.formatMessage({
            id: 'LOADING_DATA.PLEASE_WAIT',
          })}
        />
        <Text>
          {intl.formatMessage({ id: 'LOADING_DATA.PLEASE_WAIT' })}
          ...
        </Text>
      </Content>
    </Wrapper>
  );
};

LoadingData.propTypes = {
  fullmode: PropTypes.bool,
};

export default LoadingData;
